import { SvgIcon } from "@mui/material"

import { ReactComponent as Road } from "./Road-icon.svg"

export const RoadIcon = (props) => {
    return (
        <SvgIcon component={Road} inheritViewBox {...props} />
    )
}
